export default "__VITE_ASSET__bf84b0ba__"